import { createStore } from 'vuex';
import { auth } from './auth.module';
import { user } from './user.module';
import { corporate } from './corporate.module';
import pro from './pro.module';
import manifest from './manifest.module';
import { toast } from './toast.module';
import userPreferences from './modules/userPreferences';
import createPersistedState from 'vuex-persistedstate';

export default (app) =>
  createStore({
    modules: {
      auth,
      user,
      corporate,
      manifest: manifest(app),
      pro: pro(app),
      toast,
      userPreferences
    },
    plugins: [
      createPersistedState({
        paths: ['userPreferences.tablePreferences']
      })
    ]
  });
